/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import "./checkout.css";
import { Link } from "react-router-dom";
import { Translate } from "react-auto-translate";
import axios from 'axios';
import { useDispatch, useSelector } from "react-redux";
import getSymbolFromCurrency from "currency-symbol-map";
import { subtotal, subtotalget } from "../../actions/cartactions";

import { getCurrencySymbol, defaultLanguage, getShippingCharge } from '../../helpers';

const Checkoutbox = (props) => {
    const dispatch = useDispatch();

    const [refresh, setRefresh] = useState(0)
    const lastSubRef = useRef(null);
    const isCalculatingRef = useRef(false);

    const prices = useSelector((state) => state.priceList);
    const { price } = prices || {};
    const subtotals = useSelector((state) => state.subtotal);
    const { sub } = subtotals || { sub: 0 };
    const taxes = useSelector((state) => state.gettax);
    const { tax } = taxes || { tax: {} };

    const [shippingCosts, setShippingCosts] = useState('calculating shipping...')

    // Safety check - ensure we have valid data before rendering calculations
    const safeSub = typeof sub === 'number' ? sub : 0;
    const safePrice = price || 'SAR';
    const safeTax = tax && typeof tax === 'object' ? tax : {};

    useEffect(() => {
        // Only make API call if subtotal actually changed and is not currently calculating
        // Skip if subtotal is 0 or hasn't changed meaningfully
        const currentSub = safeSub;
        if (currentSub !== lastSubRef.current && !isCalculatingRef.current && currentSub > 0) {
            isCalculatingRef.current = true;
            lastSubRef.current = currentSub;
            
            const fetchShipping = async () => {
                try {
                    console.log('Calculating shipping for subtotal:', currentSub)
                    const shippingCharge = await getShippingCharge(0, currentSub)
                    console.log('shipping', shippingCharge)
                    // Ensure shippingCharge is a valid number
                    const validCharge = typeof shippingCharge === 'number' ? shippingCharge : (parseFloat(shippingCharge) || 0);
                    setShippingCosts(validCharge)
                } catch (error) {
                    console.error('Error calculating shipping:', error)
                    setShippingCosts(0)
                } finally {
                    isCalculatingRef.current = false;
                }
            };
            
            fetchShipping();
        } else if (currentSub === 0 && lastSubRef.current !== null) {
            // Reset when cart is empty
            lastSubRef.current = null;
            setShippingCosts('calculating shipping...')
        }
    }, [safeSub, refresh]);

    let defaultLanguage = localStorage.getItem('translate')

    return (
        <>
            <div className="checkout-box">
                <div className="checkout-box1">
                    <div className="checkout-summary-head">
                        <h1>{defaultLanguage === 'en' ? 'Summary' : 'الملخص'}</h1>
                    </div>
                    <div className="checkout-summary">
                        <summary>{defaultLanguage === 'en' ? 'Estimate Shipping and Tax' : 'الشحن والضرائب المقدرة'}</summary>
                    </div>
                </div>

                <div className="checkout-box2">
                    <div className="subtotal">
                        <div>{defaultLanguage === 'en' ? 'Subtotal' : 'مبلغ المجموع '}</div>
                        <div>
                            {
                                localStorage.getItem("translate") === "en"
                                    ? localStorage.getItem("currency_code")
                                    : localStorage.getItem("currency_icon")
                            }
                            {" "} {safeSub}
                        </div>
                    </div>

                    <div className="subtotal">
                        <div>{defaultLanguage === 'en' ? 'VAT' : 'الضريبة المقدرة'}</div>
                        <div>
                            {
                                localStorage.getItem("translate") === "en"
                                    ? localStorage.getItem("currency_code")
                                    : localStorage.getItem("currency_icon")
                            }
                            {" "}
                            {safeTax[safePrice] ? (safeSub * safeTax[safePrice]) / 100 : 0}
                        </div>
                    </div>

                    <div className="shipping">
                        <div>{defaultLanguage === 'en' ? 'Shipping Charges' : 'رسوم الشحن'}</div>
                        <div>
                            {
                                localStorage.getItem("translate") === "en"
                                    ? localStorage.getItem("currency_code")
                                    : localStorage.getItem("currency_icon")
                            }
                            {" "}
                            {
                                localStorage.getItem("country_code_iso3") === "KSA"
                                    ? safeSub <= 0 ? '0' : safeSub > 200
                                        ? "0 (Free)"
                                        : shippingCosts
                                    : localStorage.getItem("country_code_iso3") === "UAE"
                                        ? safeSub <= 0 ? '0' : safeSub > 200
                                            ? "0 (Free)"
                                            : shippingCosts
                                        : localStorage.getItem("country_code_iso3") === "IND"
                                            ? safeSub <= 0 ? '0' : safeSub > 4500
                                                ? "0 (Free)"
                                                : shippingCosts
                                            : ""
                            }
                        </div>
                    </div>


                    <div className="ordertotal">
                        <div>{defaultLanguage === 'en' ? 'Order Total' : 'الطلب الاجمالي'}</div>
                        <div>
                            {
                                safeSub > 0
                                    ? <>
                                        {
                                            localStorage.getItem("translate") === "en"
                                                ? localStorage.getItem("currency_code")
                                                : localStorage.getItem("currency_icon")
                                        }
                                        {" "}
                                        {
                                            (() => {
                                                const taxValue = safeTax[safePrice] || 0;
                                                const shippingValue = typeof shippingCosts === 'number' 
                                                    ? shippingCosts 
                                                    : (typeof shippingCosts === 'string' && shippingCosts !== 'calculating shipping...' 
                                                        ? parseFloat(shippingCosts) || 0 
                                                        : 0);
                                                const shippingCharge = localStorage.getItem("country_code_iso3") === "KSA"
                                                    ? safeSub <= 0 ? 0 : safeSub > 200 ? 0 : shippingValue
                                                    : localStorage.getItem("country_code_iso3") === "UAE"
                                                        ? safeSub <= 0 ? 0 : safeSub > 200 ? 0 : shippingValue
                                                        : localStorage.getItem("country_code_iso3") === "IND"
                                                            ? safeSub <= 0 ? 0 : safeSub > 4500 ? 0 : shippingValue
                                                            : 0;
                                                return (safeSub + (safeSub * taxValue) / 100) + shippingCharge;
                                            })()
                                        }
                                    </>
                                    : 0
                            }

                        </div>
                    </div>
                </div>

                <div className="checkout-box3">
                    {
                        safeSub > 0
                            ? <Link to={props.item <= 0 ? '/cart' : "/checkout"}>
                                <button
                                    onClick={() => {
                                        const taxValue = safeTax[safePrice] || 0;
                                        const shippingValue = typeof shippingCosts === 'number' ? shippingCosts : 0;
                                        localStorage.setItem("total", safeSub + (safeSub * taxValue) / 100);
                                        localStorage.setItem("tax", (safeSub * taxValue) / 100)
                                        localStorage.setItem("shipping", safeSub > 200 ? 0 : shippingValue)
                                    }}
                                >
                                    {defaultLanguage === 'en' ? 'Proceed to Checkout' : 'التحقق من ذلك'}
                                </button>
                            </Link>
                            : null
                    }
                </div>
            </div>
        </>
    );
};

export default Checkoutbox;
